import { Component } from '@angular/core';
import { DialogBase, DialogCloseReason } from '../dialogs/base-dialog';
import { TranslateService } from '@ngx-translate/core';
import { IListPropertiesModel } from './ck-editor-cd-list-properties-plugin.interface';

interface IBulletTypeItem {
  value: 'circle' | 'none' | 'disc' | 'square';
  text: string;
}

interface INumberingTypeItem {
  value: 'lower-roman' | 'upper-roman' | 'lower-alpha' | 'upper-alpha' | 'decimal';
  text: string;
}

@Component({
  selector: 'ck-editor-list-color-dialog',
  templateUrl: './ck-editor-list-properties-dialog.html',
})
export class CkEditorListPropertiesDialogComponent extends DialogBase {

  // these are just defaults we should be getting the data from the opener of this dialog
  listPropertiesModel: IListPropertiesModel = {
    isOrderedList: null,
    fontFamily: null,
    color: null,
    fontSize: null,
    isBold: false,
    isItalic: false,
    bulletType: null,
    startFrom: null,
    orderedListType: null
  };

  bulletsTypes: IBulletTypeItem[];
  numberingTypes: INumberingTypeItem[];

  persistenceKey: string;

  constructor(private translate: TranslateService ) {
    super();


    this.bulletsTypes = [
      {value: 'none', text: this.translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.BULLETS_TYPE.NONE')},
      {value: 'circle', text: this.translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.BULLETS_TYPE.CIRCLE')},
      {value: 'disc', text: this.translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.BULLETS_TYPE.DISC')},
      {value: 'square', text: this.translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.BULLETS_TYPE.SQUARE')}
    ];

    this.numberingTypes = [
      {value: 'lower-roman', text: this.translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.NUMBERING_TYPE.LOWER_ROMAN')},
      {value: 'upper-roman', text: this.translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.NUMBERING_TYPE.UPPER_ROMAN')},
      {value: 'lower-alpha', text: this.translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.NUMBERING_TYPE.LOWER_ALPHA')},
      {value: 'upper-alpha', text: this.translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.NUMBERING_TYPE.UPPER_ALPHA')},
      {value: 'decimal', text: this.translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.NUMBERING_TYPE.DECIMAL')}
    ];
  }

  initDialog() {
    // assign the model that we go (if no values supplied the defaults take place)
    Object.assign(this.listPropertiesModel, this.extraData.listProperties);
    if (this.listPropertiesModel.bulletType === null) {
      this.listPropertiesModel.bulletType = 'disc';
    }

    if (this.listPropertiesModel.orderedListType === null) {
      this.listPropertiesModel.orderedListType = 'decimal';
    }


    this.persistenceKey= this.extraData.colorsPersistenceKey;

  }

  onOk() {
    super.close({ reason: DialogCloseReason.OK, data: this.listPropertiesModel });
  }

  onCancel() {
    super.close({ reason: DialogCloseReason.CANCEL, data: {} });
  }

  colorChanged(color: string) {
    this.listPropertiesModel.color = color;
  }

  toggleStyleBold() {
    this.listPropertiesModel.isBold = !this.listPropertiesModel.isBold;
  }

  toggleStyleItalic() {
    this.listPropertiesModel.isItalic = !this.listPropertiesModel.isItalic;
  }
}

